export const createAttachmentState = () => ({
    byId: {},
    allIds: [],
    selectedIds: new Set()
});
//# sourceMappingURL=attachmentInstanceCreator.js.map